/**
 * Whether the browser believes it has a network, as a subscription rather than a reading.
 *
 * Read once, `navigator.onLine` is stale the moment the wifi comes back and the screen keeps saying the
 * person is offline. Subscribed, the message corrects itself without a reload — which matters because the
 * sentence it chooses between is *nothing is wrong with Autho* and *the server is not answering*.
 *
 * `navigator.onLine` is only trustworthy in one direction: **false means there is no network**, true means
 * the browser has an interface and nothing more. That is exactly the direction this needs.
 */
import { useSyncExternalStore } from 'react';

const subscribe = (notify: () => void) => {
  window.addEventListener('online', notify);
  window.addEventListener('offline', notify);
  return () => {
    window.removeEventListener('online', notify);
    window.removeEventListener('offline', notify);
  };
};

export function useOnline(): boolean {
  // The server snapshot is `true`: a server render has no browser to ask, and assuming *offline* there
  // would flash the wrong sentence on every first paint.
  return useSyncExternalStore(
    subscribe,
    () => window.navigator.onLine,
    () => true,
  );
}
